module.exports = __webpack_public_path__ + "media/slider/Banner-7-IND-aed1c8aa.jpg";